import { Configuration } from "@ucm-it/openapi-idm-js";

export const configuration = new Configuration({
    // FIXME: This is a hack to remove the /idm from the end of the URL. This
    //     should be fixed when the old axios implementation is removed and the
    //     .env files are updated to remove the /idm from the URL.
    basePath: process.env.REACT_APP_BASEURL.replace(/\/idm$/, ''),
    credentials: 'include',
});
